/**
 * Single file for all branded loaders (~50 max).
 *
 * Add entries keyed by sellerID AND custom domain (both if needed).
 * Each value: { store: '<html with inline css>', cart: '<html with inline css>' }
 * Unlisted sellers keep the default LazyLoader / CartLoader.
 *
 * Resolution order:
 *   1. sellerID known → that seller's loader only, else default (no cross-seller domain fallback)
 *   2. sellerID unknown → domain (custom domain before sellerID API returns)
 *
 * Example:
 *   reemjewels: { store: `...`, cart: `...` },
 *   'reemjewels.in': { store: `...`, cart: `...` },
 */

const VOGUE_STORE = `
<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#fff;font-family:Inter,system-ui,sans-serif;">
  <div style="text-align:center;max-width:320px;padding:24px;">
    <div style="width:88px;height:88px;margin:0 auto 24px;border-radius:50%;background:linear-gradient(135deg,#be123c,#e11d48);color:#fff;font-size:40px;font-weight:700;line-height:88px;">V</div>
    <div style="width:240px;height:6px;margin:0 auto 20px;background:#fce7f3;border-radius:3px;overflow:hidden;">
      <div style="width:40%;height:100%;background:linear-gradient(90deg,#be123c,#fb7185);border-radius:3px;animation:vogueBar 2s ease-in-out infinite;"></div>
    </div>
    <p style="margin:0;font-size:15px;font-weight:500;color:#9f1239;">Welcome to Vogue...</p>
  </div>
</div>
<style>@keyframes vogueBar{0%,100%{transform:translateX(-100%)}50%{transform:translateX(250%)}}</style>
`;



const VOGUE_CART = `
<div style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.92);backdrop-filter:blur(6px);z-index:10000;font-family:Inter,system-ui,sans-serif;">
  <div style="text-align:center;padding:32px;">
    <div style="width:48px;height:48px;margin:0 auto 16px;border:4px solid #fce7f3;border-top-color:#be123c;border-radius:50%;animation:vogueSpin 0.9s linear infinite;"></div>
    <p style="margin:0;font-size:15px;font-weight:500;color:#9f1239;">Preparing your Vogue checkout...</p>
  </div>
</div>
<style>@keyframes vogueSpin{to{transform:rotate(360deg)}}</style>
`;

const REEMJEWELS_STORE = `<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:#F8F4F1;
font-family:Inter,system-ui,sans-serif;
z-index:99999;
">

<div style="text-align:center;">

<div style="
position:relative;
width:120px;
height:120px;
margin:auto;
display:flex;
align-items:center;
justify-content:center;
">

<!-- Spinner -->
<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(155,111,102,.12);
border-top-color:#9B6F66;
border-right-color:#9B6F66;
animation:reemSpin 1.1s linear infinite;
"></div>

<!-- Glass Circle -->
<div style="
width:88px;
height:88px;
border-radius:50%;
background:rgba(255,255,255,.75);
backdrop-filter:blur(14px);
-webkit-backdrop-filter:blur(14px);
border:1px solid rgba(255,255,255,.8);
display:flex;
align-items:center;
justify-content:center;
box-shadow:
0 10px 30px rgba(155,111,102,.12),
inset 0 1px 8px rgba(255,255,255,.9);
">

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/reemjewels/media-library/2026/07/ef00eb52-1f2d-4e39-8873-cef4f7fde00e-6d060c13-88b9-48af-a1d3-0e7e9b2fab14-thumbnail.jpg"
style="
width:62px;
height:62px;
border-radius:50%;
object-fit:cover;
"
/>

</div>

</div>

<div style="
margin-top:22px;
font-size:13px;
letter-spacing:2px;
color:#9B6F66;
font-weight:500;
">
Loading...
</div>

</div>

</div>

<style>
@keyframes reemSpin{
from{transform:rotate(0deg);}
to{transform:rotate(360deg);}
}
</style>
`;



const REEMJEWELS_CART = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:rgba(248,244,241,.92);
backdrop-filter:blur(8px);
z-index:99999;
font-family:Inter,system-ui,sans-serif;
">

<div style="
position:relative;
width:72px;
height:72px;
display:flex;
align-items:center;
justify-content:center;
">

<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(155,111,102,.12);
border-top-color:#9B6F66;
animation:reemCartSpin .9s linear infinite;
"></div>

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/reemjewels/media-library/2026/07/ef00eb52-1f2d-4e39-8873-cef4f7fde00e-6d060c13-88b9-48af-a1d3-0e7e9b2fab14-thumbnail.jpg"
style="
width:46px;
height:46px;
border-radius:50%;
object-fit:cover;
"
/>

</div>

</div>

<style>
@keyframes reemCartSpin{
to{transform:rotate(360deg);}
}
</style>
`;

const BOOKNEXTDOOR_STORE = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:rgba(247,243,227,.82);
backdrop-filter:blur(18px);
-webkit-backdrop-filter:blur(18px);
font-family:Inter,system-ui,sans-serif;
z-index:99999;
">

<div style="text-align:center;">

<div style="
position:relative;
width:150px;
height:150px;
margin:auto;
display:flex;
align-items:center;
justify-content:center;
">

<!-- Outer Spinner -->
<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(18,74,134,.12);
border-top-color:#124A86;
border-right-color:#124A86;
animation:bndSpin 1.3s linear infinite;
"></div>

<!-- Inner Spinner -->
<div style="
position:absolute;
inset:12px;
border-radius:50%;
border:2px solid rgba(0,153,255,.10);
border-bottom-color:#1C87E5;
animation:bndSpinReverse 2s linear infinite;
"></div>

<!-- Glass Logo Holder -->
<div style="
width:92px;
height:92px;
border-radius:50%;

backdrop-filter:blur(18px);
-webkit-backdrop-filter:blur(18px);
display:flex;
align-items:center;
justify-content:center;
box-shadow:
0 12px 35px rgba(18,74,134,.12),
inset 0 1px 8px rgba(255,255,255,.9);
">

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/booknextdoor/media-library/2026/07/fdda6f44-aea5-4ccf-8e92-734b1bff6452-642655238_18087824087593142_9172868379495392800_n__1_.jpg"
style="
width:64px;
height:64px;
object-fit:contain;
"
/>

</div>

</div>

<div style="
margin-top:22px;
font-size:14px;
font-weight:500;
letter-spacing:2px;
color:#124A86;
">
Loading your next read...
</div>

</div>

</div>

<style>

@keyframes bndSpin{
from{transform:rotate(0deg);}
to{transform:rotate(360deg);}
}

@keyframes bndSpinReverse{
from{transform:rotate(360deg);}
to{transform:rotate(0deg);}
}

</style>
`;

const BOOKNEXTDOOR_CART = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:rgba(247,243,227,.82);
backdrop-filter:blur(14px);
-webkit-backdrop-filter:blur(14px);
z-index:99999;
">

<div style="
position:relative;
width:82px;
height:82px;
display:flex;
align-items:center;
justify-content:center;
">

<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(18,74,134,.12);
border-top-color:#124A86;
animation:bndCartSpin .9s linear infinite;
"></div>

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/booknextdoor/media-library/2026/07/fdda6f44-aea5-4ccf-8e92-734b1bff6452-642655238_18087824087593142_9172868379495392800_n__1_.jpg"
style="
width:48px;
height:48px;
object-fit:contain;
"
/>

</div>

</div>

<style>
@keyframes bndCartSpin{
to{transform:rotate(360deg);}
}
</style>
`;


const HYZIANDUMMI_STORE = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:#FFF4D6;
font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif;
z-index:99999;
overflow:hidden;
">

<div style="
text-align:center;
position:relative;
">

<!-- Main Playful Loader -->
<div style="
position:relative;
width:180px;
height:180px;
margin:auto;
display:flex;
align-items:center;
justify-content:center;
">

<!-- Soft background glow -->
<div style="
position:absolute;
width:130px;
height:130px;
border-radius:50%;
background:rgba(255,205,45,.12);
filter:blur(15px);
animation:hyziGlow 2s ease-in-out infinite;
"></div>

<!-- Dashed playful orbit -->
<div style="
position:absolute;
inset:7px;
border:2px dashed rgba(163,147,105,.28);
border-radius:50%;
animation:hyziOrbit 8s linear infinite;
"></div>

<!-- Orbiting yellow idea -->
<div style="
position:absolute;
top:17px;
left:50%;
width:14px;
height:14px;
margin-left:-7px;
border-radius:50%;
background:#FFD51F;
box-shadow:0 3px 10px rgba(255,213,31,.35);
animation:hyziIdea 1.5s ease-in-out infinite;
"></div>

<!-- Orbiting coral idea -->
<div style="
position:absolute;
right:24px;
bottom:45px;
width:11px;
height:11px;
border-radius:50%;
background:#F36B57;
box-shadow:0 3px 10px rgba(243,107,87,.25);
animation:hyziIdea 1.7s ease-in-out infinite .25s;
"></div>

<!-- Orbiting green idea -->
<div style="
position:absolute;
left:27px;
bottom:42px;
width:9px;
height:9px;
border-radius:50%;
background:#4F9A5A;
box-shadow:0 3px 10px rgba(79,154,90,.25);
animation:hyziIdea 1.6s ease-in-out infinite .5s;
"></div>

<!-- Logo -->
<div style="
position:relative;
width:108px;
height:108px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
overflow:hidden;
background:#FFF4D6;
box-shadow:
0 10px 28px rgba(61,83,48,.14),
0 0 0 7px rgba(255,255,255,.45);
animation:hyziBounce 2s ease-in-out infinite;
">

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/hyziandummi/media-library/2026/09/0446dc42-396f-4687-9c50-d237c2578a09-Your_paragraph_text__4_.png"
style="
width:108px;
height:108px;
object-fit:cover;
display:block;
border-radius:50%;
"
/>

</div>

</div>

<!-- Loading Message -->
<div style="
margin-top:22px;
font-size:15px;
font-weight:600;
letter-spacing:1px;
color:#A39369;
">

<span style="
display:inline-block;
animation:hyziText 1.5s ease-in-out infinite;
">
Learning
</span>

<span style="color:#F36B57;"> • </span>

<span style="
display:inline-block;
animation:hyziText 1.5s ease-in-out infinite .2s;
">
Playing
</span>

<span style="color:#F36B57;"> • </span>

<span style="
display:inline-block;
animation:hyziText 1.5s ease-in-out infinite .4s;
">
Growing
</span>

</div>

</div>

</div>

<style>

@keyframes hyziOrbit{
from{
transform:rotate(0deg);
}
to{
transform:rotate(360deg);
}
}

@keyframes hyziIdea{
0%,100%{
transform:scale(.75);
opacity:.55;
}
50%{
transform:scale(1.35);
opacity:1;
}
}

@keyframes hyziBounce{
0%,100%{
transform:translateY(0) scale(1);
}
50%{
transform:translateY(-6px) scale(1.025);
}
}

@keyframes hyziGlow{
0%,100%{
transform:scale(.9);
opacity:.5;
}
50%{
transform:scale(1.15);
opacity:1;
}
}

@keyframes hyziText{
0%,100%{
transform:translateY(0);
opacity:.65;
}
50%{
transform:translateY(-3px);
opacity:1;
}
}

</style>
`;



const HYZIANDUMMI_CART = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:rgba(255,244,214,.94);
backdrop-filter:blur(12px);
-webkit-backdrop-filter:blur(12px);
z-index:99999;
font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif;
">

<div style="
position:relative;
width:92px;
height:92px;
display:flex;
align-items:center;
justify-content:center;
">

<!-- Playful Orbit -->
<div style="
position:absolute;
inset:0;
border:2px dashed rgba(163,147,105,.30);
border-radius:50%;
animation:hyziCartOrbit 4s linear infinite;
"></div>

<!-- Coral Dot -->
<div style="
position:absolute;
top:4px;
right:12px;
width:9px;
height:9px;
border-radius:50%;
background:#F36B57;
animation:hyziCartDot 1.4s ease-in-out infinite;
"></div>

<!-- Logo -->
<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/hyziandummi/media-library/2026/09/0446dc42-396f-4687-9c50-d237c2578a09-Your_paragraph_text__4_.png"
style="
width:62px;
height:62px;
object-fit:cover;
display:block;
border-radius:50%;
animation:hyziCartBounce 1.5s ease-in-out infinite;
"
/>

</div>

</div>

<style>

@keyframes hyziCartOrbit{
from{
transform:rotate(0deg);
}
to{
transform:rotate(360deg);
}
}

@keyframes hyziCartDot{
0%,100%{
transform:scale(.7);
}
50%{
transform:scale(1.3);
}
}

@keyframes hyziCartBounce{
0%,100%{
transform:scale(1);
}
50%{
transform:scale(1.06);
}
}

</style>
`;


const MANAVATTY_STORE = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:#3D1B12;
font-family:Inter,system-ui,sans-serif;
z-index:99999;
overflow:hidden;
">

<div style="text-align:center;">

<div style="
position:relative;
width:150px;
height:150px;
margin:auto;
display:flex;
align-items:center;
justify-content:center;
">

<!-- Outer Spinner -->
<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(243,228,206,.14);
border-top-color:#F3E4CE;
border-right-color:#C9A66B;
animation:manavattySpin 1.3s linear infinite;
"></div>

<!-- Inner Spinner -->
<div style="
position:absolute;
inset:12px;
border-radius:50%;
border:2px solid rgba(243,228,206,.10);
border-bottom-color:#F3E4CE;
animation:manavattySpinReverse 2.2s linear infinite;
"></div>

<!-- Logo -->
<div style="
width:88px;
height:88px;
display:flex;
align-items:center;
justify-content:center;
">

<img
src="https://prodinent-media1.s3.ap-south-1.amazonaws.com/sellers/manavatty/media-library/2026/08/1a8f56ee-d1af-421b-8775-5dcda92e8d60-928a5b99-66b7-45a2-b244-8f768333ed12-original.jpg"
style="
width:78px;
height:78px;
object-fit:contain;
display:block;
border-radius:50%;
"
/>

</div>

</div>

<div style="
margin-top:24px;
font-size:14px;
font-weight:500;
letter-spacing:3px;
color:#F3E4CE;
">
Loading...
</div>

</div>

</div>

<style>

@keyframes manavattySpin{
from{transform:rotate(0deg);}
to{transform:rotate(360deg);}
}

@keyframes manavattySpinReverse{
from{transform:rotate(360deg);}
to{transform:rotate(0deg);}
}

</style>
`;



const MANAVATTY_CART = `
<div style="
position:fixed;
inset:0;
display:flex;
align-items:center;
justify-content:center;
background:rgba(61,27,18,.94);
backdrop-filter:blur(12px);
-webkit-backdrop-filter:blur(12px);
z-index:99999;
font-family:Inter,system-ui,sans-serif;
">

<div style="
position:relative;
width:82px;
height:82px;
display:flex;
align-items:center;
justify-content:center;
">

<div style="
position:absolute;
inset:0;
border-radius:50%;
border:3px solid rgba(243,228,206,.12);
border-top-color:#F3E4CE;
border-right-color:#C9A66B;
animation:manavattyCartSpin .9s linear infinite;
"></div>

<img
src="YOUR_MANAVATTY_LOGO_CDN_URL"
style="
width:52px;
height:52px;
object-fit:contain;
display:block;
border-radius:50%;
"
/>

</div>

</div>

<style>

@keyframes manavattyCartSpin{
to{transform:rotate(360deg);}
}

</style>
`;


export const SELLER_LOADERS = {
  vogue: { store: VOGUE_STORE, cart: VOGUE_CART },
  reemjewels: { store: REEMJEWELS_STORE, cart: REEMJEWELS_CART },
  booknextdoor: { store: BOOKNEXTDOOR_STORE, cart: BOOKNEXTDOOR_CART },
  hyziandummi: { store: HYZIANDUMMI_STORE, cart: HYZIANDUMMI_CART },
  manavatty: { store: MANAVATTY_STORE, cart: MANAVATTY_CART },
  'reemjewels.in': { store: REEMJEWELS_STORE, cart: REEMJEWELS_CART },
  'reemjewels.com': { store: REEMJEWELS_STORE, cart: REEMJEWELS_CART },
  'booknextdoor.in': { store: BOOKNEXTDOOR_STORE, cart: BOOKNEXTDOOR_CART },
  'hyziandummi.in': { store: HYZIANDUMMI_STORE, cart: HYZIANDUMMI_CART },
  'manavattystore.in': { store: MANAVATTY_STORE, cart: MANAVATTY_CART },
 
};

function normalizeDomain(domain) {
  if (!domain) return '';
  let normalized = String(domain).toLowerCase().trim();
  if (normalized.startsWith('www.')) normalized = normalized.slice(4);
  return normalized;
}

function normalizeKey(value) {
  if (!value) return '';
  return String(value).toLowerCase().trim();
}

/**
 * Resolve loader HTML config.
 * - sellerID known → only that seller's loader, or default (null). Never another seller's domain loader.
 * - sellerID unknown → domain match (custom domain before API resolves).
 * Returns null → use default LazyLoader / CartLoader.
 */
export function resolveSellerLoader({ domain, sellerID } = {}) {
  const sellerKey = normalizeKey(sellerID);

  if (sellerKey) {
    return SELLER_LOADERS[sellerKey] || null;
  }

  const normalizedDomain = normalizeDomain(domain);
  if (normalizedDomain && SELLER_LOADERS[normalizedDomain]) {
    return SELLER_LOADERS[normalizedDomain];
  }

  return null;
}
